import { uiIconSet } from './uiIconSet';
import { TemplateResult } from 'lit';

class IconSet {
  private static instance: IconSet;
  private icons: Map<string, Element>;
  private parser: DOMParser;

  private constructor() {
    this.icons = new Map<string, Element>();
    this.parser = new DOMParser();
    this.loadIconsFromUiIconSet();
  }

  public static getInstance(): IconSet {
    if (!IconSet.instance) {
      IconSet.instance = new IconSet();
    }
    return IconSet.instance;
  }

  private loadIconsFromUiIconSet(): void {
    try {
      const doc: Document = this.parser.parseFromString(uiIconSet.strings[0], 'image/svg+xml');

      // Check if the symbol with the given ID exists
      const symbols: NodeListOf<SVGSymbolElement> = doc.querySelectorAll('symbol');

      symbols.forEach((symbol: SVGSymbolElement) => {
        const id: string | null = symbol.getAttribute('id');
        if (id && !this.icons.has(id)) {
          this.icons.set(id, symbol);
        }
      });
    } catch (error) {
      throw new Error(`Error parsing SVG content: ${error}`);
    }
  }

  //this is used to add a custom icon set
  public loadCustomIconSet(iconSet: TemplateResult): void {
    try {
      const doc: Document = this.parser.parseFromString(iconSet.strings[0], 'image/svg+xml');

      // Check if the symbol with the given ID exists
      const symbols: NodeListOf<SVGSymbolElement> = doc.querySelectorAll('symbol');

      symbols.forEach((symbol: SVGSymbolElement) => {
        const id: string | null = symbol.getAttribute('id');
        if (id && !this.icons.has(id)) {
          this.icons.set(id, symbol);
        }
      });
    } catch (error) {
      throw new Error(`Error parsing SVG content: ${error}`);
    }
  }

  public getIcon(name: string): Element | undefined {
    return this.icons.get(name);
  }

  public isSVGIconAvailable(icon: string): boolean {
    return this.icons.has(icon);
  }
}

export default IconSet;
